import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { ResourceLink } from "src/app/models/resource-link";
import { DocumentService } from "src/app/services/documents.service";

@Component({
    selector: 'mwp-member-resourcs-compliance',
    templateUrl: './compliance.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MemberDocumentComplianceComponent implements OnInit {

    public resources: ResourceLink[];
    public apiUrl = ContentHeaderKey.DocumentsCompliance;

    constructor(
        private documentService: DocumentService
    ) {
    }

    ngOnInit(): void {
        this.documentService.getComplianceResources().subscribe((response: ResourceLink[]) => {
            this.resources = this.documentService.getResouceIcon(response);
        });
    }

    public openTab(url: string): void {
        window.open(url, "_blank");
    }
}